import {
  CircularProgress,
} from '@material-ui/core/';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import classes from './confirmNotification.module.scss';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

interface IProps {
  titleEn: string;
  bodyEn: string;
  titleAr: string;
  bodyAr: string;
  status: string,
  type: string;
  open: boolean;
  filter?: boolean;
  loading?: boolean;
  isEgypt?: boolean;
  hideTitle: boolean;
  internalNavigationType: any,
  link: string,
  imageEn: any[],
  imageAr: any[],
  file: File[],
  channelId: string;
  fileData: string,
  nativeModuleMethodName: string,
  nativeModuleName: string,
  handleClose(): void;
  handleSend(): Promise<void>;
  processing: boolean;
}
interface IState {
}

class ConfirmNotification extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  handleCancel = () => {
    this.props.handleClose();
  };

  render() {
    return (
      <div className={classes.alertContainer}>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Review Message</DialogTitle>
          <DialogContent className={classes.alertContainer}>
            <DialogContentText>Notification Content</DialogContentText>

            <div className={classes.filterContainer}>
              <div className={classes.search}>
                <TextField
                  onChange={() => {}}
                  autoFocus
                  margin="dense"
                  id="status"
                  label="Status"
                  fullWidth
                  value={this.props.status}
                  disabled={true}
                />
              </div>
              <div className={classes.search}>
                <TextField
                  onChange={() => {}}
                  autoFocus
                  margin="dense"
                  id="type"
                  label="Type"
                  fullWidth
                  value={this.props.type}
                  disabled={true}
                />
              </div>
            </div>

            <TextField
              onChange={() => {}}
              autoFocus
              margin="dense"
              id="Notification Channel"
              label="Notification Channel"
              fullWidth
              value={this.props.channelId}
              disabled={true}
            />

            <TextField
              onChange={() => {}}
              autoFocus
              margin="dense"
              id="titleEn"
              label="Title English"
              fullWidth
              value={this.props.titleEn}
              disabled={true}
            />

            <TextField
              onChange={() => {}}
              autoFocus
              margin="dense"
              id="bodyEn"
              label="Body English"
              fullWidth
              value={this.props.bodyEn}
              disabled={true}
            />
            <TextField
              onChange={() => {}}
              autoFocus
              margin="dense"
              id="titleAr"
              label="Title Arabic"
              fullWidth
              value={this.props.titleAr}
              disabled={true}
            />

            <TextField
              onChange={() => {}}
              autoFocus
              margin="dense"
              id="bodyAr"
              label="Body Arabic"
              fullWidth
              value={this.props.bodyAr}
              disabled={true}
            />
            {this.props.type === "external" ? (
              <TextField
                onChange={() => {}}
                autoFocus
                margin="dense"
                id="link"
                value={this.props.link}
                label="Link"
                fullWidth
                disabled={true}
              />
            ) : null}
            {this.props.type === "internal" ? (
              <TextField
                onChange={() => {}}
                autoFocus
                margin="dense"
                id="navigationType"
                value={this.props.internalNavigationType}
                label="navigationType"
                fullWidth
                disabled={true}
              />
            ) : null}
            {this.props.type === "native" ? (
              <>
                <TextField
                  autoFocus
                  margin="dense"
                  id="nativeModuleName"
                  label="Native Module Name"
                  value={this.props.nativeModuleName}

                  fullWidth
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="nativeModuleMethodName"
                  label="Native Module Method Name"
                  value={this.props.nativeModuleMethodName}
                  fullWidth
                />
              </>) : null}
            {["external", "static"].includes(this.props.type) && (
              <FormControlLabel
                control={
                  <Switch
                    checked={this.props.hideTitle}
                    onChange={(event: any) => {}}
                    color="primary"
                  />
                }
                label="Hide Title and Body"
                disabled={true}
              />
            )}
            {this.props.status === "group" ? (
              <TextField
                onChange={() => {}}
                autoFocus
                margin="dense"
                id="file"
                value={
                  this.props.file && this.props.file.length
                    ? this.props.file[0].name
                    : ""
                }
                label="file"
                fullWidth
                disabled={true}
              />
            ) : (
              ""
            )}
            <div className={classes.imagesContainer}>
              <div>
                <DialogContentText>Notification Image English:</DialogContentText>
                {this.props.imageEn.length && this.props.imageEn[0].preview ? (
                  <img
                    className={classes.image}
                    src={this.props.imageEn[0].preview}
                  />
                ) : (
                  ""
                )}
              </div>
              <div>
                <DialogContentText>Notification Image Arabic:</DialogContentText>
                {this.props.imageAr.length && this.props.imageAr[0].preview ? (
                  <img
                    className={classes.image}
                    src={this.props.imageAr[0].preview}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleCancel()} color="primary">
              Cancel
            </Button>
            <Button disabled={this.props.processing} onClick={() => this.props.handleSend()} color="primary">
              {this.props.loading ? <CircularProgress /> : "Confirm"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ConfirmNotification;
